import { IconButton, TableCell, TableRow, withStyles, makeStyles } from '@material-ui/core';
import ChatBubbleOutline from '@material-ui/icons/ChatBubbleOutline';
import CommentIcon from '@material-ui/icons/Message';
import { usePopupState } from 'material-ui-popup-state/hooks';
import React from 'react';
import styled from 'styled-components';
import FormikSimpleSelect from '../../common/FormikSimpleSelect';
import ActionsContextV2 from '../ActionsContextV2';
import ActionItemButton from './ActionItemButton';
import ActionItemMenu from './ActionItemMenuV2';
import ActionOneTimeDeviationIcon from './ActionOneTimeDeviationIcon';

const useStyles = makeStyles((theme) => ({
    root: {
        color: 'inherit',
        '&$hover:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    //hover: {},
}));

const RETURN_VALUE = 'Return';


const ActionFormApprovedGroupItemV2 = ({ formProps, itemIndex, fieldName, action, readOnly }) => {


    const context = React.useContext(ActionsContextV2);
    const classes = useStyles();

    const TextStyleContainer = styled.div`

   font-family: Roboto;
   font-size: 14px;
   font-weight: 500;
   line-height: 19px;
   text-align: left;
   
   `;


    const hyphenIfNull = text => text ? text : '-';

    const popupState = usePopupState({
        variant: 'popover',
        popupId: 'deviationReasoningPopover',
    })

    const applicabilityFieldName = `${fieldName}.applicabilityId`;
    const statusActionFieldName = `${fieldName}.statusAction`;
    const commentsFieldName = `${fieldName}.comments`;


    const statusActionButtonTitleValues = [
        { title: 'Approve', value: 'Approve' },
        { title: 'Return', value: RETURN_VALUE }
    ];


    const isEditable = action.currentUserStepIndex === 0 && action.applicabilityId !== action.originalApplicabilityId;
    const { procedureSdn, rev, effectiveDate, submitByDate, status, applicability, comments, currentUserStepIndex } = action;
    const isLevel1Editable = (currentUserStepIndex === 0 && context.actionsRedux.editableApprovedActions[action.procedureId])

    const { procedureName, iwpp, url, categoryName } = action;

    const { canRestartandcancel } = context.actionsRedux.selectedProjectFunctionDetails;

    return (

        <TableRow hover classes={classes}>
            <ActionOneTimeDeviationIcon action={action} />
            <TableCell>
                {(url && !readOnly) ?
                    <a target="_blank" href={url}>{procedureSdn}</a>
                    : procedureSdn
                }
            </TableCell>
            <TableCell>
                {procedureName}
            </TableCell>
            <TableCell>
                {categoryName ? categoryName : "-"}
            </TableCell>
            <TableCell>
                {rev}
            </TableCell>

            <TableCell>
                {isLevel1Editable ?
                    <FormikSimpleSelect
                        buttonTitleValues={context.actionsRedux.applicabilityOptions}
                        setFieldValue={formProps.setFieldValue}
                        setFieldTouched={formProps.setFieldTouched}
                        field={applicabilityFieldName}
                        value={action.applicabilityId}


                        onValueChanged={value => {
                            const applicabilityOption = context.actionsRedux.applicabilityOptionsObject[value];

                            if (applicabilityOption && applicabilityOption.requiresDeviationReasoning === true) {
                                context.displayDeviationReasoning({ deviationFieldName: fieldName, action, deviationReasoningClearApplicabilityOnCancel: true, isEditable: isLevel1Editable });
                            } else {


                                formProps.setFieldValue(`${fieldName}.deviationReasoning`, null)
                                formProps.setFieldValue(`${fieldName}.deviationComments`, null)
                                formProps.setFieldValue(`${fieldName}.modifiedProcedureSdn`, null)
                                formProps.setFieldValue(`${fieldName}.modifiedProcedureTitle`, null)
                                formProps.setFieldValue(`${fieldName}.modifiedProcedureUrl`, null)
                                formProps.setFieldValue(`${fieldName}.isDeviating`, false)
                            }

                            context.updateScrollTop(context.scrollRef.current.scrollTop);
                        }}
                    /> :
                    hyphenIfNull(applicability)
                }

            </TableCell>
            {!readOnly &&
                <TableCell>

                    {(action.deviationReasoning || action.deviationComments || action.activeOneTimeDeviation || action.oneTimeDeviationHistory.length) ?
                        <ActionItemButton
                            color="primary"
                            onClick={() => context.displayDeviationReasoning({ deviationFieldName: fieldName, action: { ...action, isEditable: false }, deviationReasoningClearApplicabilityOnCancel: false })}
                        >
                            View Reason
                        </ActionItemButton> : null
                    }

                </TableCell>
            }

            {!readOnly &&
                <TableCell>
                    {comments ?
                        <IconButton
                            color="primary"
                            onClick={() => context.displayComments({ commentsFieldName, action, commentsEditable: false })}
                        >
                            <CommentIcon />
                        </IconButton>
                        : <IconButton disabled> <ChatBubbleOutline color="primary" /></IconButton>
                    }
                </TableCell>
            }
            <TableCell>
                {canRestartandcancel &&

                    <ActionItemMenu action={action} />
                }
            </TableCell>






        </TableRow>



    );


}


export default ActionFormApprovedGroupItemV2;